import { radius, theme, Container, Flexer, Spacer } from '@taxfix/scouts-ui'

export interface CompanyAuthContainerProps {
    children: React.ReactNode
    footer: React.ReactNode
}

export const CompanyOfficerAuthContainer = ({ children, footer }: CompanyAuthContainerProps) => {
    return (
        <Flexer column gap="24px" tabletGap="48px" alignCenter justifyCenter>
            <Spacer width="100%" tabletWidth="576px">
                <Container
                    background={theme.neutral.backgroundLight}
                    padding="24px"
                    tabletPadding="30px 36px"
                    radius={radius.large}
                >
                    {children}
                </Container>
            </Spacer>
            {footer}
        </Flexer>
    )
}
